import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setSessionTokenGetter } from '@/lib/api';

/**
 * Wires the Clerk session token into the Hono RPC client. Mounted once near
 * the root so any `useJobs` call downstream already has a valid token getter.
 */
export function AuthBridge() {
  const { getToken, isSignedIn } = useAuth();
  useEffect(() => {
    setSessionTokenGetter(async () => {
      if (!isSignedIn) return null;
      try {
        return await getToken();
      } catch {
        return null;
      }
    });
  }, [getToken, isSignedIn]);
  return null;
}
